import React, { useState, useEffect } from 'react';
import { InputAdornment, TextField } from '@mui/material';

const UITextField = ({
  fieldLabel = 'Field Label',
  value = '',
  onChange = () => { },
  autoFocus = false,
  required = false,
  multiline = false,
  type = 'text', // Add a type prop to determine the input type
  endAdornment,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSSNChange = e => {
    const { value } = e.target;
    let formattedValue = value.replace(/\D/g, '').slice(0, 9); // Remove non-digits and limit length

    // Format the string as SSN without using regex
    if (formattedValue.length > 5) {
      formattedValue =
        formattedValue.slice(0, 3) +
        '-' +
        formattedValue.slice(3, 5) +
        '-' +
        formattedValue.slice(5);
    } else if (formattedValue.length > 3) {
      formattedValue =
        formattedValue.slice(0, 3) + '-' + formattedValue.slice(3);
    }

    setInputValue(formattedValue);

    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: formattedValue } });
    }
  };

  const handleChange = e => {
    if (type === 'ssn') {
      handleSSNChange(e);
    } else if (onChange) {
      onChange(e);
    }
  };

  return (
    <div>
      <div className="fxs b-500">
        {fieldLabel}
        {required && (
          <span className="text-danger b-500" style={{ fontSize: '14px' }}>
            *
          </span>
        )}
      </div>
      <TextField
        multiline={multiline}
        value={type === 'ssn' ? inputValue : value}
        onChange={handleChange}
        size="small"
        autoFocus={autoFocus}
        InputProps={{
          endAdornment: endAdornment && <InputAdornment position="end"
          sx={{
            position: 'absolute',
            right: 0,
            top: 20,
          }}>{endAdornment}</InputAdornment>,
        }}

        type={type}
        {...props}
      />
    </div>
  );
};

export default UITextField;
